<template>
  <div class="layadd">
    <el-button size="mini" round @click="handleClick">添加条件</el-button>
  </div>
</template>

<script>
export default {
  methods: {
    handleClick() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
.layadd {
  position: absolute;
  top: -14px;
  z-index: 1;
}
</style>

